var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 profile-aside-menu"},[_c('EmployeeProfileAsideMenu')],1),_c('div',{staticClass:"col-md-8"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }